import { addThousandSeparator } from 'utils/numbers';
import { sum } from 'utils/arrays';
import { decimalPrecision } from 'config/marketConfig';

export const getQuantity = (spaceType, formatOptions) =>
  addThousandSeparator(sum(spaceType.spaces, (space) => space.quantity), formatOptions);

export const getTotalSF = (spaceType, formatOptions) =>
  addThousandSeparator(
    sum(spaceType.spaces, (space) => space.quantity * space.size.width * space.size.height), { fixed: decimalPrecision, ...formatOptions }
  );
